<div class="career_detail_page" >
        <div class="detail_content" *ngIf="job">
            <div class="heading d-flex">
              <div class="d-flex left">
                <lucide-icon name="ArrowLeft" (click)="goBack()"
                class="arrow"></lucide-icon>
                <h2>{{job.title }}</h2>
                <span [ngClass]="getRoleClass(job.role)" class="role">{{ job.role }}</span>
                <span class="location">
                  <span class="icon_location">
                    <lucide-icon [name]="job.location.icon" class="icon_location"></lucide-icon>
                  </span>
                  {{ job.location.country }}
                </span>
              </div>
              <!-- <button class="apply_btn" mat-button (click)="openModal()">{{ job.buttonText }}</button> -->
              <button class="apply_btn" mat-button>{{ job.buttonText }}</button>
            </div>
          
            <div class="container">
            <div class="detail">
              <!-- Job Summary -->
              <div class="summary">
                <h3>{{ job.details.summary.heading }}</h3>
                <p>{{ job.details.summary.description }}</p>
              </div>
          
              <!-- Responsibilities -->
              <div class="Responsibility">
                <h3>{{ job.details.responsibilities.heading }}</h3>
                <ul>
                  <li *ngFor="let responsibility of job.details.responsibilities.items">{{ responsibility }}</li>
                </ul>
              </div>
          
              <!-- Qualifications -->
              <div class="qualification">
                <h3>{{ job.details.qualifications.heading }}</h3>
                <ul>
                  <li *ngFor="let qualification of job.details.qualifications.items">{{ qualification }}</li>
                </ul>
              </div>
          
              <!-- What we offer -->
              <div class="what_we_offer">
                <h3>{{ job.details.offers.heading }}</h3>
                <ul>
                  <li *ngFor="let offer of job.details.offers.items">{{ offer }}</li>
                </ul>
              </div>
            </div>


        </div>

        </div>
          
          
     

      <!-- Modal box -->
<div class="modal_box" *ngIf="isModalOpen">
  <div class="modal_content">
    <div class="modal_heading d-flex">
    <h2>Job Application</h2>

    <span class="close"> <lucide-icon (click)="closeModal()" name="X" class="icon"></lucide-icon> </span>
  </div>

  <form [formGroup]="userForm" (ngSubmit)="submitForm()">
    <div class="row">
      <div class="formGroup col-sm-6">
        <label>First Name <sup>*</sup> </label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="firstName" />
        </mat-form-field>
        <div class="error" *ngIf="userForm.get('firstName')?.invalid && userForm.get('firstName')?.touched">
          First Name is required.
        </div>
      </div>
  
      <div class="formGroup col-sm-6">
        <label>Last Name <sup>*</sup></label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="lastName" />
        </mat-form-field>
        <div class="error" *ngIf="userForm.get('lastName')?.invalid && userForm.get('lastName')?.touched">
          Last Name is required.
        </div>
      </div>
    </div>
  
    <div class="formGroup">
      <label>Email <sup>*</sup> </label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="email" />
      </mat-form-field>
      <div *ngIf="userForm.get('email')?.invalid && userForm.get('email')?.touched">
        <div class="error" *ngIf="userForm.get('email')?.errors?.['required']">Email is required.</div>
        <div class="error" *ngIf="userForm.get('email')?.errors?.['email']">Invalid email format.</div>
      </div>
    </div>
  
    <div class="formGroup">
      <label>Experience Level <sup>*</sup></label>
      <mat-form-field appearance="outline">
        <mat-select formControlName="experience" placeholder="Select Experience Level">
          <mat-option *ngFor="let level of experienceLevels" [value]="level.value">
            {{ level.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="error" *ngIf="userForm.get('experience')?.invalid && userForm.get('experience')?.touched">
        Experience is required.
      </div>
    </div>
  
    <div class="formGroup">
      <label>Resume <sup>*</sup></label>
      <input type="file" (change)="onFileChange($event)" />
      <div class="error" *ngIf="userForm.get('resume')?.invalid && userForm.get('resume')?.touched">
        Resume is required.
      </div>
    </div>
  
    <div class="btn_row d-flex">
      <button mat-button class="cancel_btn" (click)="closeModal()">Cancel</button>
      <!-- <button mat-button class="apply_btn submit" type="submit">Submit Detail</button> -->
      <button mat-button class="apply_btn submit" type="submit">Submit Detail</button>
    </div>
  </form>
  
  
    

    
   
  </div>
</div>
    

</div>
